//Require static assets
var Hogan = require('hogan.js');
    const template = '{{# years}}<li class="entry -year">{{year}}</li>{{# entries}}<li class="entry -{{timescale}} {{#first-transaction-of-year}}-firstofyear{{/first-transaction-of-year}}"><div class="entry-date">{{#present}}<strong>Today</strong><br> {{/present}} {{{date-month}}} {{date-day}} <br> {{time}}</div><ol class="entry-transactions">{{# sessions}}<li class="session" data-session-id="{{id}}">{{# transactions}}<div class="transaction {{#view-details}}transaction-has-details{{/view-details}} section--{{color}}" data-type="{{type}}" data-policy="{{policy}}"><div class="transaction-type"><span class="geico-icon icon-{{type}}"></span></div><div class="transaction-content"><h3>{{title}}</h3><p>{{summary}}</p>{{#view-link}}<a href="{{link-url}}" class="transaction-details-button"><span>{{link-text}}</span></a>{{/view-link}} {{#view-link-btn}}<a href="{{link-url}}" class="btn btn--primary btn--{{color}} btn--full-mobile"><span>{{link-text}}</span></a>{{/view-link-btn}}<div class="transaction-details-action">                                                      {{#view-balance}}<div class="transaction-balance">Balance: <span>{{balance}}</span></div>{{/view-balance}}</div> {{#view-details}}<a class="transaction-details-toggle"><span>Details</span></a><div class="transaction-details">{{{details}}}</div>{{/view-details}}</div><div class="transaction-action">{{#view-link-desktop}}<a href="{{link-url}}" class="btn btn--primary btn--{{color}}"><span>{{link-text}}</span></a>{{/view-link-desktop}}                      {{^view-link}}{{#view-balance}}<div class="transaction-balance">Balance<br> <span>{{balance}}</span></div>{{/view-balance}}{{#view-details}}<div class="transaction-divider"></div><div class="transaction-details-link"><a href="javascript:void(0)" class="transaction-details-toggle"><span>Details</span></a></div>{{/view-details}}{{/view-link}}     </div></div>{{/ transactions}}</li>{{/ sessions}}</ol></li>{{/ entries}}{{/ years}}{{^ years}}<li class="entry -no-results"><p>Your search has returned 0 results.<br> Please, try again.</p></li>{{/ years}}';

const HoganTemplate = Hogan.compile(template);

//Module Imports
import baseComponent from '../baseComponent';

const validateSettings = [
    {
        setting                 :   "content",
        isRequired              :   true,
        validate                :   "type",//a type or a value
        possibleValues          :   ["string","object"],
        errorMessage            :   ["GDK Timeline : Content must be defined and set to a DOM selector or Node"]
    },
    {
        setting                 :   "data",
        isRequired              :   true,
        validate                :   "type",//a type or a value
        possibleValues          :   ["object"],
        errorMessage            :   ["GDK Timeline : Data must be a valid JSON object"]
    }
];

class Timeline{
    /**
     * Refer to the design kit section of this component for JS examples and setting details.
     * @param {string, Object} content
     *  A reference to the html timeline node
     *
     * @param {JSON Object} data
     * A reference to a valid JSON object which will be used to render the initial state of the timeline
     *
     */
    constructor(options) {

        this._internalVars = {
            node: null,//used for content item
            data : null,
            transactionDetails: null
        };

        //options with defaults set
        this._defaults = {};

        // Create options by extending defaults with the passed in arugments
        if (options && typeof options === "object") {
            this._options = baseComponent.extendDefaults(this._defaults, options);
        }

        //if the required options are valid set up the environment
        if( baseComponent.validateSettings(this._options, validateSettings) ){
            this._internalVars.contentType = baseComponent.getContentType(this);
            setLocalVars.call(this);
            setEvents.call(this);
            // render data
            render.call(this);
        }
    }

    //Public Methods
    /**
    * update()
    * Rerender timeline with new data
    */
    update(data){

        let output = HoganTemplate.render(data);
        this._internalVars.node.innerHTML = output;

    }

    /**
     * destroy()
     * removes the node from the dom and any events attached
     */
    destroy(){
        removeEvents.call(this);
		this._internalVars.node.parentNode.removeChild(this._internalVars.node);

		//a little garbage collection
		for (var variableKey in this){
			if (this.hasOwnProperty(variableKey)){
				delete this[variableKey];
			}
		}
    }

}

// Private Methods
/**
 * render()
 * Initial Render of Timeline
 */
function render(el) {
    
    let output = HoganTemplate.render(this._internalVars.data);
    
    this._internalVars.node.innerHTML = output;
}
/**
 * setEvents()
 * Sets all the events needed for the component
 */
function setEvents() {

    live('.transaction.transaction-has-details', "click", function(){ 
        detailsClickHandler(this);
    }, this._internalVars.node);
}


/**
 * removeEvents()
 * removes all events from the component
 */
function removeEvents() {

   // TODO need to fix with new live handler
   //remove click events

    this._internalVars.transactionDetails = this._internalVars.node.querySelectorAll(".transaction-has-details");

   Array.prototype.forEach.call(this._internalVars.transactionDetails, (el, i)=>{
       el.removeEventListener("click",detailsClickHandler.bind(this));
   });
}

/**
 * detailsClickHandler()
 * Opens details drawer for specified transaction
 */
function detailsClickHandler(el){

    // toggle class
    el.classList.toggle("transaction-details-open");

}

/**
 * findAncestor()
 * Finds nearest ancestor with specified class
 */
function findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}



/**
 * setLocalVars()
 * set all the local vars to passed in options
 */
function setLocalVars() {
    //determine the type of content passed in
    if(this._internalVars.contentType === 'string'){
        this._internalVars.node = document.querySelector(this._options.content);
    }else if(this._internalVars.contentType === 'domNode'){
        this._internalVars.node = this._options.content;
    }

    this._internalVars.data = this._options.data;

}

function addEvent(el, type, handler) {
    if (el.attachEvent) el.attachEvent('on'+type, handler); else el.addEventListener(type, handler);
}

// live binding helper with CSS selector
function live(selector, event, callback, context) {
    addEvent(context || document, event, function(e) {
        var qs = (context || document).querySelectorAll(selector);
        if (qs) {
            var el = e.target || e.srcElement, index = -1;
            while (el && ((index = Array.prototype.indexOf.call(qs, el)) === -1)) el = el.parentElement;
            if (index > -1) callback.call(el, e);
        }
    });
}


export default Timeline;



// WEBPACK FOOTER //
// ./src/js/geico-design-kit/components/Timeline.js